<template>
    <a
        v-smooth-scroll="{ offset: offsetAmount }"
        :href="`#${jumpTo}`"
    >
        <slot />
    </a>
</template>
<script>
export default {
    name: 'BaseJumpLink',
    props: {
        jumpTo: {
            type: String,
            required: true,
        },
        offsetAmount: {
            type: Number,
            default: 0,
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/BaseJumpLink.vue